import { render, staticRenderFns } from "./ViewUploads.vue?vue&type=template&id=33d73414&scoped=true&"
import script from "./ViewUploads.vue?vue&type=script&lang=js&"
export * from "./ViewUploads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d73414",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/happoproperty.jp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d73414')) {
      api.createRecord('33d73414', component.options)
    } else {
      api.reload('33d73414', component.options)
    }
    module.hot.accept("./ViewUploads.vue?vue&type=template&id=33d73414&scoped=true&", function () {
      api.rerender('33d73414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/core/components/ViewUploads.vue"
export default component.exports